import React from 'react'
import { css } from '@emotion/css'
import clsx from 'clsx'

export const Header = () => {
  return (
    <div className={clsx()}>
      <div
        className={clsx(
          '!font-avenir flex items-center px-6 pt-6 text-[15px] font-[500] text-black-400',
        )}
      >
        Create tool by importing OpenAPI Spec
      </div>
    </div>
  )
}

export const FileListHeader = () => {
  return (
    <div
      className={clsx(
        gridStyle,
        css`
          border-bottom: 0.5px solid #d3d3d3;
          background-color: #fafafa;
        `,
      )}
    >
      <div
        className={clsx(
          '!font-avenir flex items-center text-[14px] font-[500] tracking-[0.03px]',
          css`
            font-family: 'Cera Pro';
          `,
        )}
      >
        Name
      </div>
      <div
        className={clsx(
          'flex items-center justify-end font-[400] text-[#]',
          css`
            font-size: 13px;
          `,
        )}
      >
        Action
      </div>
    </div>
  )
}

export const StepRow = ({
  children,
  className,
  count,
}: {
  children: React.ReactNode
  className?: string
  count: number
}) => {
  return (
    <div
      className={clsx(
        css`
          background-color: #fff;
          padding: 0px 24px;
          font-family: 'Gilroy';
          position: relative;
          padding-bottom: 42px;
        `,
        className,
      )}
    >
      <div className="absolute left-[22px] top-[0px] h-full w-[.5px] bg-grey-200">
        <div className="flex  h-full justify-center">
          <div className="flex flex h-[20px] min-w-[20px] items-center items-center justify-center justify-center rounded-[4px] border border-grey-200 bg-[white] pt-[1px] text-[12px] font-[500] text-black-500">
            {count}
          </div>
        </div>
      </div>
      <div className="w-full pl-8">{children}</div>
    </div>
  )
}

export const TableRow = ({
  left,
  right,
  className,
}: {
  left: React.ReactNode
  right: React.ReactNode
  className?: string
}) => {
  return (
    <div
      className={clsx(
        gridStyle,
        css`
          background-color: #fff;
          padding: 12px 24px;
          font-family: 'Gilroy';
          height: 80px;
          border-bottom: 0.5px solid transparent;
        `,
        className,
      )}
    >
      <div className="flex items-center">{left}</div>
      <div className="flex justify-end">{right}</div>
    </div>
  )
}

const gridStyle = css`
  display: grid;
  grid-template-columns: 3fr 1.5fr;
  gap: 10px;
  font-size: 13px;
  color: #6b6b6b;
  padding: 6px 24px;
  color: #343434;

  font-family: 'Gilroy';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.15px;
  min-height: 42px;
`

export const Table = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className={clsx(css`
        overflow: hidden;
        border-radius: 12px 12px 12px 12px;
        border: 0.5px solid #d3d3d3;
        background:
          linear-gradient(
            0deg,
            rgba(243, 243, 243, 0.2) 0%,
            rgba(243, 243, 243, 0.2) 100%
          ),
          #fff;
      `)}
    >
      {children}
    </div>
  )
}
